export const styles = theme => ({
    sidebar: {
        backgroundColor: "white",
        width: 230,
        margin: "0 30px 0 0",
        padding: "0",
        position: "sticky" as const,
        top: "5%",
        "& ul": {
            margin: 0,
            listStyle: "none",
            padding: "10px 0 0 24px",
        },
        "& li h6": {
            padding: "6px 0",
            cursor: "pointer",
            textDecoration: "none",
            color: "#009",
            fontFamily: "Arial,Verdana,Helvetica,sans-serif",
            "&:hover": {
                textDecoration: "underline",
            }
        },
        "& h6": {
            fontSize: 14,
        },
    },
    menuActive: {
        fontFamily: "Arial,Verdana,Helvetica,sans-serif",
        fontWeight: 600,
        textDecoration: "underline",
    },
    menuInactive: {},
    subcategory: {
        "& h6": {
            marginLeft: 10,
            fontFamily: "Arial,Verdana,Helvetica,sans-serif",
            fontSize: 12,
        }
    },
    subcategoryActive: {
        "& h6": {
            fontWeight: 600,
        }
    },
    subcategoryInactive: {},
    sidebarTitle: {
        textTransform: "uppercase",
        // color: "#f5f5f5",
        fontSize: 12,
        padding: "24px 0 0 24px",
    } as const,
});